
import request from "../utils/request";

export function cmsUserList(data) {
    return request({
        url: "/userinfo/cmsUserList",
        data: data,
    });
}
export function cmsUserBanned(data) {
    return request({
        url: "/userinfo/cmsUserBanned",
        data: data,
    });
}

export function cmsRechangeRank(data) {
    return request({
        url: "/userinfo/cmsRechangeRank",
        data: data,
    });
}

export function cmsConsumeRank(data) {
    return request({
        url: "/userinfo/cmsConsumeRank",
        data: data,
    });
}

export function cmsUserMessage(data) {
    return request({
        url: "/userinfo/cmsUserMessage",
        data: data,
    });
}


export function cmsUserGamelist(data) {
    return request({
        url: "/userinfo/cmsUserGamelist",
        data: data,
    });
}
export function cmsCoinChange(data) {
    return request({
        url: "/userinfo/cmsCoinChange",
        data: data,
    });
}

export function cmsIntegralChange(data) {
    return request({
        url: "/userinfo/cmsIntegralChange",
        data: data,
    });
}

export function cmsRechange(data) {
    return request({
        url: "/pay/cmsSelRechange",
        data: data,
    });
}

export function cmsUserBoxList(data) {
    return request({
        url: "/userbox/cmsUserBoxList",
        data: data,
    });
}


export function cmsUserInfo(data) {
    return request({
        url: "/userinfo/cmsUserInfo",
        data: data,
    });
}


export function getCensusData(data) {
    return request({
        url: "/census/getCensusData",
        data: data,
    });
}

export function queryPackageOrders(data) {
    return request({
        url: "/pay/queryPackageOrders",
        data: data,
    });
}

export function seldateuser(data) {
    return request({
        url: "/pay/seldateuser",
        data: data,
    });
}

